<template>
	<div id="SearchProductLocationModalComponent">
		<div class="modal fade" id="searchProductLocationModalComponent" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Buscador de Articulos</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-inline">
                                    <input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchProducts"
                                        v-model="searchProducts"
                                        v-on:keyup.enter="getAllProductsLocal(1)"
                                        @focus="$event.target.select()">
                                    <button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllProducts(1)">Buscar</button>
                                </div>
                                <table class="table table-sm table-hover table-12">
                                    <thead>
                                        <tr class="text-center">
                                            <th>Código</th>
                                            <th>Nombre</th>
                                            <th>ISBN</th>
                                            <th>Encua.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in listProducts" :key="index" @click="setProductoLocation(item)" class="pointer" :class="(idSelect == item.id) ? 'bg-info':''">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.name }}</td>
                                            <td class="text-center">{{ item.isbn }}</td>
                                            <td class="text-center">{{ item.type_binding }}</td>
                                            <td v-if="idSelect == item.id"><i class="fas fa-caret-right"></i></td>
                                        </tr>
                                    </tbody>
                                </table>                                
                            </div>
                            <div class="col-md-4">
                                <div class="card card-info">
                                    <div class="card-header">
                                        <h3 class="card-title">Ubicacion<span v-if="product_locations.length > 1">es</span></h3>
                                    </div>
                                    <!-- /.card-header -->
                                    <div class="card-body">
                                        <table class="table table-sm table-hover table-12" v-if="product_locations.length > 0">
                                            <thead>
                                                <tr class="text-center">
                                                    <th>Bodega</th>
                                                    <th>Rack</th>
                                                    <th>Modulo</th>
                                                    <th>Cantidad</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="text-center" v-for="(it, index) in product_locations" :key="index">
                                                    <td>{{ it.store }}</td>
                                                    <td>{{ it.store_rack }}</td>
                                                    <td>{{ it.store_rack_module }}</td>
                                                    <td>{{ it.quantity }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-else>
                                            Sin Resultados
                                        </div>
                                    </div>
                                    <!-- /.card-body -->
                                </div>

                            </div>
                        </div>
					</div>
					<div class="modal-footer text-left">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" ref="btnCloseSearchProductLocationModalComponent">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import mixin from '@/mixins'
    import errors from '@/mixins/errors.js'
    import axiosAction from '@/mixins/axiosAction.js'
    import product from '@/mixins/products'
    import store from '@/mixins/stores'
    import storeRack from '@/mixins/stores/storeRack.js'
    import storeRackModule from '@/mixins/generals/storeRackModule.js'

	export default {
		name: 'SearchProductLocationModalComponent',
        mixins: [mixin, errors, axiosAction, product, store, storeRack, storeRackModule],
        props: [],
		data () {
			return {
                product_locations: [],
                idSelect: -1
			}
		},
		computed: {
		},
		methods: {
            initComponentLocal() {
            },
            getAllProductsLocal(page) {
                this.idSelect = -1
                this.getAllProducts(page)
            },
            getAllProductsResultLocal(response) {
                if(this.listProducts.length > 0) {
                    this.setProductoLocation(this.listProducts[0])
                }
            },
            setProductoLocation(item) {
                this.idSelect = item.id
                this.product_locations = item.product_locations
            },
            resultAxiosLocal(responseLocal, response) {
                this.$emit('hideLockScreen')
                switch(responseLocal) {
                    case 'getAllProductsResult': this.getAllProductsResult(response); break;
                    default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
                }
            },
		},
        mounted () {
	    	this.initComponentLocal()
	    }
	}</script>

	<!-- Add "scoped" attribute to limit CSS to this component only -->
	<style scoped lang="scss">
</style>
